import styled from 'styled-components';

export const Container = styled.div``;

export const ListContainer = styled.div`
  margin: ${({ theme }) => `0 ${theme.spacing(6)} ${theme.spacing(1)}`};
`;
